<template>
  <!-- <div class="oauth-newpass-container">
    <div class="">
      <ValidationProvider
        name="newpassword"
        rules="Passwordrequired|passMinLen:8|nodigitsonlypass|passclause|passUnAcceptable|passwordBlkList"
        v-slot="{ errors ,classes }"
      >
        <div class="oauth-input-left form-group no-gutters">
          <div class="oauth-newpass-input-container">
            <label class="labeltiny" for="New_password">New password*</label>
            <input
              @input="checkPassword"
              v-model="newpassword"
              type="password"
              class="form-control form-fields pswdField"
              :class="classes"
              id="newpassword"
              name="newpassword"
              aria-required="true"
              placeholder="********"
              maxlength="20"
            >
            <span id="newpassword-help-block" class="help-block para2 my-6">{{ errors[0] }}</span>
          </div>
        </div>
      </ValidationProvider>
      <div class="oauth-input-right pswdCriteria" style="margin-top: 16px; margin-bottom: 26px;">
        <div class="password-criteria">
          <div style="margin:12px;">
                    <p class="pas-str">Password strength : {{pwdResetStrength}}</p>
                    <div class="pwd-progress-bar" v-bind:style="{ borderLeft: computedPwdProgress }">
                    </div> <br />
            <div v-for="(req, i) in pwdReq" :key="i">
              <a
                class="col-xs-1 tick_small-icon"
                v-if="req.required"
                :class="{'matched-tick':pwdReqMatch[i].matched=='matched'}"
              ></a>
              <p class="pas-str1" v-if="req.required">
                <span></span>
                {{ req.display_msg }}
              </p>
            </div>
          </div>
        </div>
        <div id="pointer"></div>
      </div>
      <ValidationProvider
        name="password"
        rules="Passwordrequired|passwordMatch:@newpassword"
        v-slot="{ errors ,classes }"
      >
        <div class="form-group no-gutters oauth-w50 oauth-mb100">
          <div class="">
            <label class="labeltiny" for="Confirm_new_password">Re-enter password*</label>
            <input
              v-model="confirmpassword"
              class="form-control form-fields marbottom30 pswdField"
              type="password"
              :class="classes"
              id="confirmpassword"
              name="confirmpassword"
              aria-required="true"
              placeholder="********"
              maxlength="20"
            >
            <span id="confirmpassword-help-block" class="help-block para2 my-6">{{ errors[0] }}</span>
          </div>
        </div>
      </ValidationProvider>
    </div>
  </div> -->
  <div>
    <div class="vbg-ff-form-container-main">
      <div class="vbg-ff-form-container-main-group1">
        <label for="pwd" class="vbg-ff-input-label">New password</label>
        <div class="vbg-icon-input-group">
          <input
            id="pwd"
            name="pwd"
            v-model="userPwd"
            :type="show1 ? 'text' : 'password'"
            class="vbg-rsp-input-field"
            :class="
              userPwd
                ? passwordInvalidClass() == 'orangeLoader'
                  ? 'vbg-input-warning'
                  : 'vbg-input-sucess'
                : ''
            "
            @input="checkPassword"
            @focus="showSuggestionBox()"
            @blur="hideSuggestionBox()"
            autocomplete="new-password"
          />
          <div
            :class="
              userPwd
                ? passwordInvalidClass() == 'orangeLoader'
                  ? 'vbg-warning-icon'
                  : 'vbg-success-icon'
                : ''
            "
          >
            <img
              :src="
                userPwd
                  ? passwordInvalidClass() == 'orangeLoader'
                    ? warningIcon
                    : checkIcon
                  : ''
              "
            />
          </div>
          <div class="vbg-show-icon">
            <span v-if="!show1 && userPwd" class="vbg-rsp-link" @click="show1 = !show1">Show</span>
            <span v-if="show1 && userPwd" class="vbg-rsp-link" @click="show1 = !show1">Hide</span>
          </div>
          <div class="vbg-ff-input-success">
            <span v-if="passwordInvalidClass() == 'greenLoader'"
              >Password strength : {{ pwdResetStrength }}</span
            >
            <span
              v-else-if="
                passwordInvalidClass() == 'orangeLoader' &&
                userPwd &&
                invalidCharacters &&
                !enhanceFpFlow
              "
              >Please enter a valid password</span
            >
            <span
              v-else-if="
                passwordInvalidClass() == 'orangeLoader' &&
                userPwd &&
                checkSequenceValidationError &&
                enhanceFpFlow
              "
              >Avoid sequences like abcd, 1234, AAAA, 1111.</span
            >
            <span
              v-else-if="
                passwordInvalidClass() == 'orangeLoader' &&
                passwordBlkListValidation &&
                enhanceFpFlow
              "
              >Password is too easy to guess. Try another.</span
            >
            <span v-else-if="
            passwordInvalidClass() == 'orangeLoader' && 
            userPwd && enhanceFpFlow && 
            !this.displaySuggestionBox
            "
            >Password doesn't meet all requirement</span
            >
          </div>
        </div>
      </div>
      <div v-if="displaySuggestionBox" class="password-criteria-container">
        <div class="password-criteria">
          <div>
            <span class="pas-str"
              >Password strength :
              {{ userPwd.length > 0 ? pwdResetStrength : "" }}</span
            >
            <!-- progress bar -->
            <div class="pwd-progress-bar">
              <div
                class="pwd-progress-bar-black"
                v-bind:style="{ width: computedPwdProgress }"
              ></div>
            </div>

            <div
              v-for="(req, i) in pwdReq"
              :key="i"
              style="display: flex; height: 20px"
            >
              <div
                v-if="req.required"
                :class="[
                  pwdReqMatch[i].matched == 'matched'
                    ? 'vbg-tick-mark'
                    : 'unmatched-dot',
                  req.type == 'cannot_contain_special_characters'
                    ? 'validationStyle'
                    : '',
                ]"
              >
                <img
                  v-if="pwdReqMatch[i].matched == 'matched'"
                  :src="checkIcon"
                />
              </div>
              <div
                v-if="req.required"
                class="pwd-progress-bar-text"
                :class="
                  req.type == 'cannot_contain_special_characters'
                    ? 'martop18'
                    : ''
                "
              >
                {{ req.display_msg }}
              </div>
            </div>
          </div>
        </div>
        <div id="pointer"></div>
      </div>
    </div>
    <div
      class=""
      v-if="
        passwordInvalidClass() == 'greenLoader' ||
        (passwordInvalidClass() == 'orangeLoader' &&
          userPwd &&
          invalidCharacters &&
          !enhanceFpFlow) ||
        (passwordInvalidClass() == 'orangeLoader' &&
          userPwd &&
          checkSequenceValidationError &&
          enhanceFpFlow) ||
        (passwordInvalidClass() == 'orangeLoader' &&
          passwordBlkListValidation &&
          enhanceFpFlow)
      "
    ></div>
    <div class="vbg-ff-form-container-second-group">
      <label for="pwdConfirm" class="vbg-ff-input-label" :class="passwordInvalidClass() == 'orangeLoader'? 'vbg-rsp-disabled-label' : ''" 
        >Re-enter password
      </label>
      <div class="vbg-icon-input-group">
        <input
          id="pwdConfirm"
          name="pwdConfirm"
          v-model="userReenteredPwd"
          :type="show2 ? 'text' : 'password'"
          class="vbg-rsp-input-field"
          :class="passwordInvalidClass() == 'orangeLoader' ? 'vbg-rsp-disabled-label' : 
            userReenteredPwd
              ? repasswordValidClass() == 'orangeLoader'
                ? 'vbg-input-warning'
                : 'vbg-input-sucess'
              : ''
          "
          autocomplete="new-password"
          @click.right.prevent
          @copy.prevent
          @paste.prevent
          :disabled="passwordInvalidClass() == 'orangeLoader'? true : false"
        />
        <div
          v-if="passwordInvalidClass() != 'orangeLoader'"
          :class="
            userReenteredPwd
              ? repasswordValidClass() == 'orangeLoader'
                ? 'vbg-warning-icon'
                : 'vbg-success-icon'
              : ''
          "
        >
          <img
            :src="
              userReenteredPwd
                ? repasswordValidClass() == 'orangeLoader'
                  ? warningIcon
                  : checkIcon
                : ''
            "
          />
        </div>
        <div class="vbg-show-icon" :class="passwordInvalidClass() == 'orangeLoader' ? 'vbg-rsp-disabled-label': ''">
          <span v-if="!show2 && userReenteredPwd" @click="show2 = !show2" class="vbg-rsp-link"
            >Show</span
          >
          <span v-if="show2 && userReenteredPwd" @click="show2 = !show2" class="vbg-rsp-link"
            >Hide</span
          >
        </div>
        <div
          class="vbg-ff-input-success"
          :class="passwordInvalidClass() == 'orangeLoader' ? 'vbg-rsp-disabled-label': ''"
          v-if="userReenteredPwd && repasswordValidClass() == 'greenLoader'"
        >
          <span>Password match: Yes</span>
        </div>
        <div
          class="vbg-ff-input-success"
          :class="passwordInvalidClass() == 'orangeLoader' ? 'vbg-rsp-disabled-label': ''"
          v-if="userReenteredPwd && repasswordValidClass() == 'orangeLoader'"
        >
          <span>Passwords do not match.</span>
        </div>
      </div>
    </div>
    <div
      class="input-success-mobile"
      v-if="
        (userReenteredPwd && repasswordValidClass() == 'greenLoader') ||
        (userReenteredPwd && repasswordValidClass() == 'orangeLoader')
      "
    ></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import loadingImage from "@/common/assets/styles/corp/images/circle-loaderWHITE_48x48.gif";
import warningIcon from "@/common/assets/styles/corp/images/warning.png";
import checkIcon from "@/common/assets/styles/corp/images/checkmark.png";
export default {
  name: "PasswordComponent",
  data() {
    return {
      // url:
      //   iamvar_cdnUrl +
      //   iamvar_imgSourceContext +
      //   "/business/login/includes/circle-loaderWHITE_48x48.gif",
      // newpassword: "",
      // confirmpassword: "",
      // value: 0,
      // max: 100,
      // variant: "progress-bar  progress-bar-success",
      // pwdResetStrength: "",
      // errorMsg: "",
      // passErrormsg: "",
      // wrongEmail: false,
      // pwdValid: false,
      // valid: false,
      // noOfPwdRequirements: 0,
      // passwordBlkList: false,
      // pwdProgressWidth: "25px solid black",
      userPwd: "",
      userReenteredPwd: "",
      pwdResetSuggestion: null,
      pwdResetStrength: "", // Strong/Medium/Weak
      pwdValid: false,
      pwdProgressWidth: "10%",
      passwordBlkList: false,
      invalidCharacters: false,
      warningIcon: warningIcon,
      checkIcon: checkIcon,
      show1: false,
      show2: false,
      displaySuggestionBox: false,
      passwordBlkListValidation: false,
      checkSequenceValidationError: false,
      url:
        iamvar_cdnUrl +
        iamvar_imgSourceContext +
        "/business/login/includes/circle-loaderWHITE_48x48.gif",
      invalidCharRegex: /[@()_~`!#$%\^&*+=\-\[\]\\';,/{}|\\": <>\?]/
    };
  },
  mounted() {
    this.$emit("child-disablePrimaryButton", "disabled");
  },
  methods: {
    ...mapActions("profile", [
      "getPassswordBlackList",
      "containsBlackListPassword",
      "loggSequences"
    ]),

    checkPassword: function () {
      this.passwordBlkListValidation = false;
      if (this.enhanceFpFlow) {
        for (let i = 0; i < this.pwdReq.length; i++) {
          if (this.pwdReq[i].required) {
            if (this.pwdReq[i].type === "length") {
              if (
                this.userPwd.length >= this.pwdReq[i].range.low &&
                this.userPwd.length <= this.pwdReq[i].range.high
              ) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            } else if (this.pwdReq[i].type === "lowercase_letter") {
              if (/[a-z]/.test(this.userPwd)) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            } else if (this.pwdReq[i].type === "number") {
              if (/\d/.test(this.userPwd)) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            } else if (
              this.pwdReq[i].type === "cannot_contain_special_characters"
            ) {
              let invalidCharsRegex = new RegExp(/[<>]/);
              if (!invalidCharsRegex.test(this.userPwd) && this.userPwd) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            } else if (this.pwdReq[i].type === "special_characters") {
              let validCharsRegex = new RegExp(
                /[-\\~`{:;"'?.|,}/[!@#$%^&*()_+=\]]/
              );
              if (validCharsRegex.test(this.userPwd) && this.userPwd) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            }
          }
        }
        this.containsBlackListPassword(this.userPwd);
        if (this.userPwd != "" && this.userPwd.length > 0) {
          if (!this.success) {
            this.passwordBlkListValidation = false;
          } else {
            this.passwordBlkListValidation = true;
          }
        }
        this.checkSequence();
      } else {
        for (let i = 0; i < this.pwdReq.length; i++) {
          if (this.pwdReq[i].required) {
            if (this.pwdReq[i].type === "length") {
              if (this.userPwd.length >= this.pwdReq[i].range.low) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            } else if (this.pwdReq[i].type === "uppercase_letter") {
              if (/[A-Z]/.test(this.userPwd)) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            } else if (this.pwdReq[i].type === "lowercase_letter") {
              if (/[a-z]/.test(this.userPwd)) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            } else if (this.pwdReq[i].type === "number") {
              if (/\d/.test(this.userPwd)) {
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.pwdReqMatch[i].matched = "unmatched";
              }
            }
            // blacklist password
            else if (this.pwdReq[i].type === "complexity") {
              this.containsBlackListPassword(this.userPwd);
              if (
                !this.success &&
                this.userPwd != "" &&
                this.userPwd.length > 0
              ) {
                this.passwordBlkList = true;
                this.pwdReqMatch[i].matched = "matched";
              } else {
                this.passwordBlkList = false;
                this.pwdReqMatch[i].matched = "unmatched";
              }
            }
            ////
          }
        }
        // reset invalid characters
        this.invalidCharacters = false;

        // check for invalid characters (<,>,")
        let invalidCharsRegex = new RegExp(/["<>]/);
        if (invalidCharsRegex.test(this.userPwd) && !this.enhanceFpFlow) {
          this.invalidCharacters = true;
        }
      }
      this.displaySuggestionBox = true;
    },
    changePwdProgressWidth: function (pwdStrength) {
      // if(pwdStrength === 'Weak') {
      //   this.pwdProgressWidth = '25px solid black'
      // } else if(pwdStrength === 'Medium') {
      //   this.pwdProgressWidth = '100px solid black'
      // } else if(pwdStrength === 'Strong') {
      //   this.pwdProgressWidth = '210px solid black'
      // }
      if (pwdStrength === "Weak") {
        this.pwdProgressWidth = "10%";
      } else if (pwdStrength === "Medium") {
        this.pwdProgressWidth = "70%";
      } else if (pwdStrength === "Strong") {
        this.pwdProgressWidth = "100%";
      }
    },
    passwordInvalidClass() {
      if (
        !this.pwdValid ||
        this.invalidCharacters ||
        this.passwordBlkListValidation ||
        this.checkSequenceValidationError
      )
        return "orangeLoader";
      return "greenLoader";
    },
    repasswordValidClass() {
      if (this.isRePwdValid()) return "greenLoader";
      return "orangeLoader";
    },
    isRePwdValid() {
      if (this.userPwd === this.userReenteredPwd) {
        return true;
      } else return false;
    },
    showSuggestionBox: function () {
      this.displaySuggestionBox = true;
    },
    checkSequence: function () {
      let sequenceMatched = false;
      this.checkSequenceValidationError = false;
      let convertToLowerCase = this.userPwd.toLowerCase();
      let checkString = convertToLowerCase.split("");
      let dupString = this.userPwd.split('');
      let sequenceVal = ''
      let requestPayload = ''
      for(let i = 3; i < checkString.length; i++) {
        if (!(this.invalidCharRegex.test(checkString[i]))) {
          if((checkString[i].charCodeAt() - checkString[i - 1].charCodeAt() == 1) && (checkString[i - 1].charCodeAt() - checkString[i - 2].charCodeAt() == 1) && (checkString[i - 2].charCodeAt() - checkString[i - 3].charCodeAt() == 1)) {
            sequenceMatched = true;
            sequenceVal = dupString[i - 3] + dupString[i - 2] + dupString[i - 1] + dupString[i]
            break;
          }
          if((checkString[i].charCodeAt() - checkString[i - 1].charCodeAt() == 0) && (checkString[i - 1].charCodeAt() - checkString[i - 2].charCodeAt() == 0) && (checkString[i - 2].charCodeAt() - checkString[i - 3].charCodeAt() == 0)) {
            sequenceMatched = true;
            sequenceVal = dupString[i - 3] + dupString[i - 2] + dupString[i - 1] + dupString[i];
            break;
          }
          if((checkString[i].charCodeAt() - checkString[i - 1].charCodeAt() == -1) && (checkString[i - 1].charCodeAt() - checkString[i - 2].charCodeAt() == -1) && (checkString[i - 2].charCodeAt() - checkString[i - 3].charCodeAt() == -1)) {
            sequenceMatched = true;
            sequenceVal = dupString[i - 3] + dupString[i - 2] + dupString[i - 1] + dupString[i];
            break;
          }
        }
      }
      if (sequenceMatched) {
        this.checkSequenceValidationError = true;
        requestPayload = {
          'userID': this.uuID,
          'sequence': sequenceVal
        }
        this.loggSequences(requestPayload)
      }
    },
    hideSuggestionBox: function () {
      this.displaySuggestionBox = false;
    },
  },
  computed: {
    // ...mapGetters("forgotflow", ["pwdReq", "noOfPwdReq"]),
    ...mapGetters("profile", [
      "passwordBlackListC",
      "passwordBlackListE",
      "success",
      "pwdReq",
      "noOfPwdReq",
      "logOutGotoUrl",
      "enhanceFpFlow",
      "uuID"
    ]),
    pwdReqMatch: {
      get: function () {
        return this.$store.getters["profile/pwdReqMatch"];
      },
      set: function (newVal) {
        this.$store.dispatch("profile/updatePwdReqMatch", newVal);
      },
    },
    computedPwdProgress: function () {
      return this.userPwd.length > 0 ? this.pwdProgressWidth : "0%";
    },
  },

  watch: {
    pwdValid: function (newVal) {
      if (newVal) {
        if (this.userPwd.length >= 8 && this.userPwd.length < 10 && !this.passwordBlkListValidation) {
          this.pwdResetStrength = "Medium";
          this.changePwdProgressWidth("Medium");
        } else if (this.userPwd.length >= 10 && !this.passwordBlkListValidation) {
          this.changePwdProgressWidth("Strong");
          this.pwdResetStrength = "Strong";
        }
      }
      // if not valid, default pwd bar to weak
      if (!newVal) {
        this.changePwdProgressWidth("Weak");
      }
    },
    gotoProfileSettings: function (newVal) {
      if (newVal) {
        this.$router.push({
          path: "overview",
          query: { target: this.logOutGotoUrl },
        });
      }
    },

    pwdReqMatch: {
      deep: true,
      handler(newVal) {
        var noMatched = 0;
        for (var i = 0; i < newVal.length; i++) {
          if (newVal[i].required) {
            if (newVal[i].matched === "unmatched") {
              this.pwdValid = false;
              this.pwdResetStrength = "Weak";
              break;
            } else {
              noMatched += 1;
              if (noMatched === this.noOfPwdReq) {
                this.pwdValid = true;
              }
            }
          }
        }
      },
    },
    userPwd: function (newVal) {
      if (this.pwdValid) {
        if (newVal.length < 8) {
          this.changePwdProgressWidth("Weak");
        } else if (newVal.length >= 8 && newVal.length < 10 && !this.passwordBlkListValidation) {
          this.pwdStrengthClass = "progress-bar-warning";
          this.pwdResetStrength = "Medium";
          this.changePwdProgressWidth("Medium");
        } else if (newVal.length >= 10 && !this.passwordBlkListValidation) {
          this.pwdStrengthClass = "progress-bar-success";
          this.pwdResetStrength = "Strong";
          this.changePwdProgressWidth("Strong");
        }
      }
      if (
        !this.userPwd ||
        !this.userReenteredPwd ||
        this.userPwd != this.userReenteredPwd ||
        this.pwdResetStrength == "Weak" ||
        this.invalidCharacters ||
        this.passwordBlkListValidation ||
        this.checkSequenceValidationError
      ) {
        this.$emit("child-disablePrimaryButton", "disabled");
      } else {
        this.$emit("child-disablePrimaryButton", "");
      }
      this.$emit("child-newpassword", this.userPwd);
      this.$emit("child-passwordBlkList", this.enhanceFpFlow ? this.passwordBlkListValidation : this.passwordBlkList);
    },
    userReenteredPwd: function () {
      if (
        !this.userPwd ||
        !this.userReenteredPwd ||
        this.userPwd != this.userReenteredPwd ||
        this.pwdResetStrength == "Weak" ||
        this.invalidCharacters ||
        this.passwordBlkListValidation ||
        this.checkSequenceValidationError
      ) {
        this.$emit("child-disablePrimaryButton", "disabled");
      } else {
        this.$emit("child-disablePrimaryButton", "");
      }
      this.$emit("child-confirmpassword", this.userReenteredPwd);
    },
    show1: function (newVal) {
      if (newVal) {
        setTimeout(() => {
          this.show1 = false;
        }, 10000);
      }
    },
    show2: function (newVal) {
      if (newVal) {
        setTimeout(() => {
          this.show2 = false;
        }, 10000);
      }
    },
  },
};
</script>
<style scoped>
/* .passErrormsg1 {
  color: rgb(205, 4, 11);
  font-weight: bold;
}

.passErrormsg2 {
  color: btn_primary_black;
  font-weight: bold;
}

.matched {
  text-decoration: line-through;
}
.password-criteria {
  background: white;
  -moz-border-radius: 10px;
  width: 247px;
  height: auto;
  border: 1px solid black;
  margin: 0px 0 0 1px;
}
#pointer {
  margin: -148px 0 0 -3px;
  border: 1px solid black;
  width: 8px;
  height: 8px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  border-right: none;
  border-top: none;
  background: white;
}
.pas-str {
  font-size: 10px;
  letter-spacing: 0;
  line-height: 16.8px;
  font-family: NeueHaasGroteskDisplay !important;
  color: #000;
}
.pas-str1 {
  font-size: 10px;
  letter-spacing: 0;
  line-height: 16.8px;
  color: #000;
  margin-bottom: 8px;
}
.matched-tick {
  opacity: 1.5;
}
.progress{
      margin-top: 5px;
    margin-bottom: 7px;
}
.progress-bar {
  background-color: #000;
  background-image: none !important;
}
.pwd-progress-bar {
    background-color: white;
    
    border-width: 1px;
   
    height: 8px;
    width: 100%;
}

@media (max-width: 1024px) {
  .pswdCriteria {
    padding-left: 0 !important;
  }
  .oauth-newpass-container {
    margin-top: 26px !important;
  }
  #pointer {
    display: none !important;
  }
  .password-criteria{
    width: 100% !important;
  }
}
@media (min-width: 1025px) {
  .oauth-input-left {
    float: left;
    width: 50%;
  }
  .oauth-input-right {
    float: right;
    width: 47%;
  }
  .oauth-w50 {
    width: 50%
  }
  .oauth-mb100 {margin-bottom: 100px !important; margin-top: 16px;}
} */

.vbg-icon-input-group {
  position: relative;
}
.vbg-icon-input-group input {
  width: 100%;
}
.vbg-input-warning {
  border: 1px solid #ed7000 !important;
  border-bottom: 4px solid #ed7000 !important;
}
.vbg-input-warning:focus {
  border: 1px solid #ed7000 !important;
  border-bottom: 4px solid #ed7000 !important;
}
.vbg-input-sucess {
  border-bottom: 4px solid #008330 !important;
}
.vbg-input-sucess:focus {
  border-bottom: 4px solid #008330 !important;
}
.vbg-warning-icon {
  height: 18.04px;
  width: 18.04px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 12px;
  right: 62px;
}
.vbg-warning-icon img {
  height: 18.04px;
  width: 18.04px;
}
.vbg-success-icon {
  height: 17px;
  width: 17px;
  border: 1px solid black;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 12px;
  right: 62px;
}
.vbg-success-icon img {
  height: 8px;
  width: 8px;
}
.vbg-show-icon {
  height: 20px;
  width: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 12px;
  /* text-decoration: underline; */
  cursor: pointer;
  letter-spacing: 0.5px;
  font-size: 16px;
}
.matched-tick {
  opacity: 2;
}
.pwd-progress-bar {
  display: flex;
  align-items: center;
  /* background-color: white; */
  background-color: #d8dada;
  /* border: black solid; */
  border-width: 2px;
  /* border-left: 40px solid black; */
  height: 1px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 16px;
}
p {
  margin: 5px;
}
.unmatched-dot {
  height: 6px;
  width: 6px;
  background-color: #000000;
  border-radius: 100%;
  margin-right: 10px;
  margin-top: 6px;
  margin-bottom: 10px;
}
.pwd-progress-bar-black {
  background-color: black;
  height: 2px;
}
.vbg-tick-mark {
  margin-right: 10px;
  width: 6px;
  height: 20px;
}
.vbg-tick-mark img {
  height: 12px;
  width: 12px;
}
.vbg-tick-mark.validationStyle {
  margin-top: 19px;
}

.unmatched-dot.validationStyle {
  margin-top: 26px;
}
.pwd-progress-bar-text {
  font-size: 12px;
  letter-spacing: 0;
  line-height: 20px;
  width: 155px;
}
.description-height {
  height: 40px;
}
.vbg-ff-input-success {
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 8px;
  font-family: 'VzNHGeTX-reg11' !important;
  color: #000 !important;
}
.password-criteria {
  background: white;
  -moz-border-radius: 10px;
  height: 172px;
  border: 1px solid black;
  padding: 16px 16px 16px 20px;
  box-sizing: content-box;
}
#pointer {
  margin: -170px 0 0 -4px;
  border: 1px solid black;
  width: 8px;
  height: 8px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  border-right: none;
  border-top: none;
  background: white;
}
.pas-str {
  font-size: 12px;
  margin-bottom: 4px;
  letter-spacing: 0;
  line-height: 14px;
  font-family: NeueHaasGroteskDisplay !important;
  color: #000;
}
.vbg-ff-input-label {
  font-family: 'VzNHGeTX-reg11' !important;
}
.vbg-rsp-disabled-label {
  color: #d8dada !important;
  cursor: not-allowed;
}
input::-ms-reveal,
input::-ms-clear {
  display: none;
}
/* from mobile to tablet screen */
@media (max-width: 1024px) {
  .vbg-ff-form-container-main {
    position: relative;
    height: 64px;
  }
  .password-criteria {
    /* width: 100%; */
  }
  .password-criteria-container {
    margin-top: 0 !important;
    margin-bottom: 20px !important;
    padding: 0 !important;
    height: 208px;
    position: absolute;
    bottom: 47px;
    max-width: 328px;
    width: 100%;
  }
  #pointer {
    margin: -4px 0 0 18px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  .input-success-mobile {
    height: 24px;
  }
  .vbg-ff-form-container-second-group {
    height: 64px;
    margin-top: 24px;
  }
}
/* only for desktop view */
@media (min-width: 1025px) {
  .vbg-ff-form-container-main-group1 {
    float: left;
  }
  .vbg-icon-input-group {
    width: 278px !important;
  }
  .vbg-ff-form-container-main {
    max-width: 625px;
    height: 64px;
  }
  .password-criteria-container {
    float: right;
    width: 333px;
    height: 205px;
  }
  .password-criteria {
    width: 280px;
  }
  .input-success-mobile {
    display: none !important;
  }
  .vbg-ff-form-container-second-group {
    height: 64px;
    margin-top: 48px;
  }
}
</style>
